// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__3fuNB","row":"styles_row__2uRLN"};